import React from "react";

export default function Loader() {
  return (
    <div
      style={{
        marginTop: 90,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 18
      }}
    >
      Loading...
    </div>
  );
}
